import { createContext } from "react";

export type SidebarCollapseContextValue = {
  forceCollapsed: boolean;
  setForceCollapsed: (collapsed: boolean) => void;
};

const noop = () => {};

export const SidebarCollapseContext = createContext<SidebarCollapseContextValue>({
  forceCollapsed: false,
  setForceCollapsed: noop,
});
